<template>
    <div class="optional-gifts" v-if="optionalItemData && optionalItemData.length">
        <div class="optional-num g-top">
            <div class="num-bg"></div>
            <p>可{{ formatCaseNum(optionalItemData.length) }}选{{  formatCaseNum(optionalItemData[0].allOpCount) }}</p>
        </div>
        <div class="optional-item" v-for="optionalItem in optionalItemData">
            <img :src="optionalItem.smallPic" alt class="g-img" />
            <div class="g-name">{{ optionalItem.shortName || optionalItem.name }}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'optionalGiftItem',
    props: ["optionalItemData"],
    methods: {
        formatCaseNum(val) {
            if (val) {
                return this.numberToChinese(val)
            } else {
                return ''
            }
        },
        /*
            数字转中文(只支持一百以内的)
            @number {Integer} 形如23的数字
            @return {String} 返回转换成的形如 二十三 的字符串
        */
        numberToChinese(number) {
            const chars = '零一二三四五六七八九'
            const a = (number + '').split('')
            const s = []
            if (a.length === 1) {
                return chars.charAt(a[0])
            } else if (a.length === 2) {
                a.forEach((el, index) => {
                    s.push(chars.charAt(el))
                    if (index !== 1) {
                        s.push('十')
                    }
                })
                if (s[0] === '一') {
                    s.shift()
                }
                if (s[s.length - 1] === '零') {
                    s.pop()
                }
                return s.toString().replaceAll(',', '')
            } else {
                return ''
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.vivo-fontscale-4,
.vivo-fontscale-5 {
    .giveaway-item {
        width: 178px !important;
        height: 229px !important;
    }

    .optional-gifts {
        height: 229px;

        .optional-item {
            width: 178px;
        }
    }
}

.optional-num {
    color: #1d4eff;
    @include fontColor(#1d4eff, #4790ff);

    .num-bg {
        position: absolute;
        width: 100%;
        height: 100%;
        background: linear-gradient(105.2deg, #3360ff 20.64%, #4790ff 83.86%);

        @media (prefers-color-scheme: dark) {
            background: #9ba6cc;
        }

        opacity: 0.3;
    }
}

.optional-gifts {
    display: flex;
    height: 209px;
    margin-right: 19px;
    padding: 0 8px;
    @include borderColor(1111, 0.8px, solid, #c2e0ff, rgba(255, 255, 255, 0.15));
    border-radius: 18px;
    box-sizing: border-box;

    .optional-item {
        width: 108px;
        margin-right: 4px;
        @include flex-center;
        flex-direction: column;

        &:last-child {
            margin-right: 0;
        }

        img {
            width: 108px;
            height: 108px;
            margin-top: 35px;
            margin-bottom: 16px;
            display: block;
        }

        .g-name {
            height: 30px;
            line-height: 30px;
            color: #888;
            font-size: 27px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;
            width: 100%;
            margin-top: 3px;
            padding: 0 2px;
            box-sizing: border-box;
        }
    }

    .g-top {
        position: absolute;
        top: 0;
        left: 50%;
        width: 124px;
        height: 34px;
        line-height: 34px;
        transform: translateX(-50%);
        border-radius: 0 0 12px 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;

        p {
            font-size: 24px;
            transform-origin: center;
            white-space: nowrap;
        }
    }
}

.optional-list {
    ::v-deep.v-list-view__right-text {
        font-size: 39px;
    }
}
</style>